import type { Asset } from '@vaultsfyi/common'

import type { BackendVault } from '@/types'

export function isVaultAssetInTokens(vault: BackendVault, tokens: Asset['symbol'][]): boolean {
  if (tokens.length === 0) return true
  return tokens.includes(vault.asset.symbol)
}
